module.exports = __webpack_public_path__ + "static/media/registro.511edcae.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/global/registro.png
// module id = 256
// module chunks = 0